import React from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ReportSelector = ({ sites, selectedSiteId, selectedDate, onSiteChange, onDateChange, onGenerate, loading }) => {
  const siteOptions = [
    { value: '', label: 'Select a site...' },
    ...(sites || [])?.map(s => ({ value: s?.id, label: s?.site_name }))
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6 max-w-xl mx-auto mt-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="FileBarChart" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Generate Daily Site Report</h2>
          <p className="text-sm text-muted-foreground">Select a site and date to generate a report</p>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1">Site</label>
          <Select
            options={siteOptions}
            value={selectedSiteId}
            onChange={(e) => onSiteChange(e?.target?.value)}
            placeholder="Select a site..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">Report Date</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange(e?.target?.value)}
            max={new Date()?.toISOString()?.split('T')?.[0]}
            className="w-full px-3 py-2 border border-border rounded-md text-sm text-foreground bg-background focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
          />
        </div>

        <Button
          variant="primary"
          size="md"
          iconName="FileBarChart"
          onClick={onGenerate}
          disabled={!selectedSiteId || !selectedDate || loading}
          className="w-full"
        >
          {loading ? 'Generating...' : 'Generate Report'}
        </Button>
      </div>
    </div>
  );
};

export default ReportSelector;
